import React, { useEffect, useRef, useState } from 'react'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import AppBar from '../components/app-bar'
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Button, Box, CircularProgress, AppBar as AppBarHistory, Typography, TableContainer, makeStyles, Select, MenuItem, Divider, InputLabel, FormControl, Menu, Dialog, TextField, Popover, Tooltip } from '@material-ui/core'
import { customTheme } from '../styling'
import axiosInstance from '../axios'
import languageTargetIcon from '../images/translator/language-target.svg'
import worldIcon from '../images/translator/world-icon.svg'
import AddIcon from '@mui/icons-material/Add';
import deleteSvg from '../images/delete-icon.svg';
import condividiSvg from '../images/condividi.svg'
import TextSnippetIcon from '@mui/icons-material/TextSnippet'
import CloseIcon from '@mui/icons-material/Close'
import SnackBar from '../components/snackbar'
import iconClean from '../images/icon-clean.svg'
import { INTERNAL_SERVER_ERROR_MESSAGE } from '../constants'
import moment from 'moment';
import DownloadIcon from '@mui/icons-material/Download'
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile'
import { openaiAsync, registerCost, toBase64 } from '../utils'
import deleteIcon from '../images/delete-icon.svg'
import forbidden from '../images/403.jpg'
import OutlinedInput from '@material-ui/core/OutlinedInput'
import InputAdornment from '@material-ui/core/InputAdornment'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import CheckIcon from '@material-ui/icons/Check'

const useStyles = makeStyles(theme => ({
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    padding: theme.spacing(4),
    height: '100vh',
    overflow: 'auto',
  },
  title: {
    color: 'black'
  },

  textarea: {
    fontSize: '1rem',
    border: '1px solid #000',
    paddingLeft: '1rem',
    paddingTop: '1rem',
    border: 'none',
    borderColor: 'none',
    resize: 'none',
    width: '100%',
    borderRadius: 15,
    height: '53vh',
    boxShadow: `0 0 2px inset ${customTheme.colors.ui.greenVeryLight}`,
    '&:focus': {
      outline: 'none !important',
      outlineColor: '#B91F26',
      border: '1px solid #ba1f26 !important'
    },
  },

  input: {
    position: 'relative',
    top: '0.5rem',
    marginLeft: '1rem',
  },
  formControl: {
    minWidth: 300, marginRight: '1.5rem'
  },
  selectWhite: {
    backgroundColor: '#fff',
    '&:focus': {
      backgroundColor: '#fff',
    },
  },
}))

const languages = [
  {
    id: 1, text: 'Italiano', value: 'it', ai: 'italian',
  },
  {
    id: 2, text: 'Inglese', value: 'en', ai: 'english',
  },
  {
    id: 3, text: 'Francese', value: 'fr', ai: 'french',
  },
  {
    id: 4, text: 'Greco', value: 'gr', ai: 'greek',
  },
  {
    id: 5, text: 'Portoghese', value: 'pt', ai: 'portuguese',
  },
  {
    id: 6, text: 'Spagnolo', value: 'es', ai: 'spanish',
  },
  {
    id: 7, text: 'Tedesco', value: 'de', ai: 'german',
  }
]

const toRailsLang = (x) => (x === 'gr' ? 'el' : x)

const Translator = () => {
  const inputRef = useRef(null)
  const { enqueueSnackbar } = SnackBar.Consumer()
  const classes = useStyles()
  const [translating, setTranslating] = useState(false)
  const [language, setLanguage] = useState(null)
  const [languageTarget, setLanguageTarget] = useState(null)
  const [textFileTranslated, setTextFileTranslated] = useState('')
  const [textareaTranslation, setTextareaTranslation] = useState('')
  const [textareaTranslated, setTextareaTranslated] = useState('')
  const [file, setFile] = useState(null)
  const [savedTranslationOpen, setSavedTranslationOpen] = useState(false)
  const [savedTranslations, setSavedTranslations] = useState([])
  const [userDetails, setUserDetails] = useState(null)
  const [saveTranslationModal, setSaveTranslationModal] = useState(false)
  const [savedTranslationName, setSavedTranslationName] = useState('')
  const [openDeleteModal, setOpenDeleteModal] = useState(null)
  const [loading, setLoading] = useState(false)
  const [deletingTranslation, setDeletingTranslation] = useState(false)
  const [users, setUsers] = useState([])
  const [anchorEl2, setAnchorEl2] = React.useState(null);
  const openMenuUser = Boolean(anchorEl2);
  const [loadingGrant, setLoadingGrant] = useState([])
  const [showmenu, setshowmenu] = useState(null)
  const [savingTranslation, setSavingTranslation] = useState(false)

  const getLangLabel = (val) => languages.find(l => l.value === val)?.text || ''
  const [openOrigin, setOpenOrigin] = useState(false)
  const [openTarget, setOpenTarget] = useState(false)

  const textareaRef = useRef(null)


  const blobToBase64 = (blob) => new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result); // "data:<mime>;base64,..."
    reader.readAsDataURL(blob);
  });


  
  const handleClose = () => {
    setAnchorEl2(null);
    setshowmenu(null)
  };

  const handleRemoveGrant = async (id, email) => {
    setLoadingGrant([...loadingGrant, email])
    try {
      const body = {email}
      await axiosInstance.post(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/translations/${id}/revoke`, body)
      const res  = await axiosInstance.get(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/translations`)

      setSavedTranslations(res.data.payload.translations)
      
    } catch (error) {
      enqueueSnackbar({ variant: 'error', message: INTERNAL_SERVER_ERROR_MESSAGE })
    } finally {
      setLoadingGrant(loadingGrant.filter((loadingGrantId) => loadingGrantId !== email))
    }
  }

  const handleAddGrant = async (id, email) => {
    setLoadingGrant([...loadingGrant, email])
    try {
      const body = {email}
      await axiosInstance.post(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/translations/${id}/grant`, body)
      const res  = await axiosInstance.get(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/translations`)

      setSavedTranslations(res.data.payload.translations)
    } catch (error) {
      enqueueSnackbar({ variant: 'error', message: INTERNAL_SERVER_ERROR_MESSAGE })
    } finally {
      setLoadingGrant(loadingGrant.filter((loadingGrantId) => loadingGrantId !== email))
    }
  }

  
  


  useEffect(() => {
      setLoading(true)
      axiosInstance.get(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/translations`).then((res) => {
        setSavedTranslations(res.data.payload.translations)
      }).catch(error => {
        setLoading(false)
      })
      axiosInstance.get(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/user`, {
      }).then((res) => {
        setUserDetails(res.data.payload)
      }).catch(error => {
        
      }).finally(() => {
        setLoading(false)
      })
      axiosInstance.get(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/users`, {
      }).then((res) => {
        setUsers(res.data.payload.users)
      }).catch(error => {
  
      })
    
    
  }, [])


  const handleTranslation = async () => {
    setTextFileTranslated('')
    setTextareaTranslated('')
    setTranslating(true)
    if (file) {
      try {
        const data = new FormData();
        data.append('file', file)
        data.append('origin', language)
        data.append('target', languageTarget)
        data.append('user_id', userDetails?.id)

        for (const [k, v] of data.entries()) {
          console.log(k, v)
        }
        console.log('file instanceof File?', file instanceof File)

        const textTranslated = await axiosInstance.post(`${process.env.REACT_APP_API_DOMAIN}/aisolutions/bstranslator/file/`, data, {})
        const doc = textTranslated?.data?.document 
        if (!doc) { 
          enqueueSnackbar({ variant: 'error', message: 'Non è stato possibile tradurre il documento: l’API non ha restituito il file tradotto.' }); 
          setTranslating(false);
          return 
        }
        setTextFileTranslated(doc);
      } catch (error) {
        enqueueSnackbar({ variant: 'error', message: INTERNAL_SERVER_ERROR_MESSAGE })
      } finally {
        setTranslating(false)
      }


    } else {
      
      
      try {
        let finalText = '';
        let initialText = '';
        let send = `Original Language:${language} Target Language: ${languageTarget} send: ${textareaTranslation}`
        let force_response = []
        force_response.push({type:0, text: 'Original Language:English Target Language: Italian send: Good morning. We are a renowned Italian bank ready to help our customers.' })
        force_response.push({type:1, text: 'Buongiorno. Siamo una rinomata banca italiana pronta ad aiutare i nostri clienti.' })
        force_response.push({type:0, text: 'Original Language:English Target Language: Portuguese send: Good morning. We are a renowned Italian bank ready to help our customers.' })
        force_response.push({type:1, text: 'Bom dia. Somos um renomado banco italiano pronto para ajudar nossos clientes.' })
        force_response.push({type:0, text: 'Original Language:English Target Language: French send: Good morning. We are a renowned Italian bank ready to help our customers.' })
        force_response.push({type:0, text: 'Bonjour. Nous sommes une banque italienne renommée prête à aider nos clients.' })

        const completion = await openaiAsync(force_response, send, 'Translator')
        
        for await (const chunk of completion) {
          if (chunk?.choices[0]?.delta?.content){
              if (finalText === ''){
                  finalText = initialText + chunk.choices[0].delta.content;
              } else {
                finalText = finalText + chunk.choices[0].delta.content;
              }
              setTextareaTranslated(finalText)
          }
          if (chunk.usage){
            registerCost(0,'TEXT TRANSLATOR', userDetails?.id,chunk.usage.total_tokens)
          }
        }
      } catch (error) {
        enqueueSnackbar({ variant: 'error', message: INTERNAL_SERVER_ERROR_MESSAGE })
      } finally {
        setTranslating(false)
      }
    }






  }



  const downloadTranslated = async (doc) => {
    try {
      const url = `${process.env.REACT_APP_API_DOMAIN}/aisolutions/bstranslator/file/?document=${encodeURIComponent(doc)}`; 
      const resp = await axiosInstance.get(url, { responseType: 'blob' });

      // nome sugerido
      let filename = (file?.name || 'documento').replace(/(\.[\w\d_-]+)$/i, '_tradotto$1');

      const blobUrl = window.URL.createObjectURL(resp.data);
      // abrir em nova aba:
      // window.open(blobUrl, '_blank');

      // ou forçar download:
      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(blobUrl);
    } catch (e) {
      enqueueSnackbar({ variant: 'error', message: 'Non è stato possibile scaricare il file tradotto.' });
    }
  };


  const handleFileUpload = (e) => {
    const filesRaw = e.target.files
    if (!filesRaw) return

    const file = filesRaw[0]
    setTextareaTranslated('')
    setFile(file)
  }

  const handleClickFileUpload = (e) => {
    e.preventDefault()

    if (!inputRef || !inputRef.current) return

    inputRef.current.click()
  }

  const [isDragging, setIsDragging] = useState(false)

  const handleDragEnter = (e) => {
    e.preventDefault()
    setIsDragging(true)
  }

  const handleDragOver = (e) => {
    e.preventDefault()
  }

  const handleDragLeave = () => {
    setIsDragging(false)
  }

  const handleDrop = (e) => {
    e.preventDefault()
    setIsDragging(false)

    const files = e.dataTransfer.files
    setTextareaTranslated('')
    setFile(files[0])
    // Upload files to the server
  }


  const handleSave = async () => {
    if (savingTranslation) return;
    setSavingTranslation(true);
    try {
      const railsOrigin = toRailsLang(language);
      const railsTarget = toRailsLang(languageTarget);

      const body = { translation: { name: savedTranslationName, target_language: railsTarget } };

      if (file) {
        // 1) base64 do ORIGINAL
        const originalBase64 = await toBase64(file);

        // 2) baixa o TRADUZIDO no Django
        const url = `${process.env.REACT_APP_API_DOMAIN}/aisolutions/bstranslator/file/?document=${encodeURIComponent(textFileTranslated)}`;
        const resp = await axiosInstance.get(url, { responseType: 'blob' });

        // 3) blob -> data URL base64
        const translatedBase64 = await blobToBase64(resp.data);

        // 4) payload para o backoffice
        const originalName = file.name || 'documento';
        const translatedName = originalName.replace(/(\.[\w\d_-]+)$/i, '_tradotto$1') || (savedTranslationName || 'tradotto');

        body.translation.source_document_attributes = {
          language: railsOrigin,
          data: originalBase64,
          filename: savedTranslationName || originalName,
          content_type: file.type || 'application/octet-stream',
        };

        body.translation.target_document_attributes = {
          language: railsTarget,
          data: translatedBase64,
          filename: savedTranslationName || translatedName,
          content_type: resp.data.type || file.type || 'application/octet-stream',
        };
      } else {
        // texto livre
        body.translation.source_document_attributes = {
          language: railsOrigin,
          content: textareaTranslation,
        };
        body.translation.target_document_attributes = {
          language: railsTarget,
          content: textareaTranslated,
        };
      }

      await axiosInstance.post(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/translations`, body);
      const res = await axiosInstance.get(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/translations`);
      enqueueSnackbar({ variant: 'success', message: 'Traduzione salvata correttamente' });
      setSavedTranslations(res.data.payload.translations);
      setSaveTranslationModal(false);
    } catch (error) {
      // ver os erros reais do backoffice
      console.log(error?.response?.data);
      enqueueSnackbar({ variant: 'error', message: INTERNAL_SERVER_ERROR_MESSAGE });
    } finally {
      setSavingTranslation(false);
    }
  };


  const [anchorEl, setAnchorEl] = useState(null);
  const [tooltipClip, setTooltipClip] = useState('')
  const handleClickPopover = (event) => {
    setAnchorEl(event.currentTarget);
  }

  const handleClosePopover = () => {
    setAnchorEl(null);
  }

  const open = Boolean(anchorEl)
  const id = open ? 'simple-popover' : undefined

  const copyToClipboard = () => {
    navigator.clipboard.writeText(textareaTranslated);
    setTooltipClip('Copied to clipboard!')
    setTimeout(() => {
      setTooltipClip(null)
    }, 1000)

  }

  const handleDeleteArchive = async() => {
    setDeletingTranslation(true)
    try {
      const textTranslated = await axiosInstance.delete(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/translations/${openDeleteModal}`)
      enqueueSnackbar({variant:'success', message:'Traduzione eliminata correttamente'})
      setOpenDeleteModal(null)
      axiosInstance.get(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/translations`).then((res) => {
        setSavedTranslations(res.data.payload.translations)
      })

    } catch (error) {
        enqueueSnackbar({variant:'error', message:INTERNAL_SERVER_ERROR_MESSAGE})
    }finally{
      setDeletingTranslation(false)
    }
    
  } 

  const handleDownloadCartaIntestata = async (type, text) => {
    const body = { "template": type, "text": text }
    try {
      const response  = await axiosInstance.post(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/render_template`, body, { responseType: 'blob' })
      
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(response.data)
      link.download = `${type}-${moment().format('YYYY-MM-DD HH:mm')}.docx`
      link.click()
    } catch (error) {
      enqueueSnackbar({variant:'error', message:INTERNAL_SERVER_ERROR_MESSAGE})
      console.log('error', error)
    }
    
  }

  const handleDownload = async (filename, text) => {
    try {
      const element = document.createElement('a');
      element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
      element.setAttribute('download', filename + '.txt')

      element.style.display = 'none';
      document.body.appendChild(element);

      element.click();

      document.body.removeChild(element);

    } catch (error) {
      enqueueSnackbar({variant:'error', message:INTERNAL_SERVER_ERROR_MESSAGE})
      console.log('error', error)
    }
    
  }

  const downloadFromArchive = async (td) => {
    try {
      // 1) conteúdo texto direto
      if (td?.content) {
        return handleDownload(td.filename || 'download', td.content)
      }

      // 2) data URL (se algum endpoint vier assim)
      if (td?.data?.startsWith('data:')) {
        const a = document.createElement('a')
        a.href = td.data
        a.download = td.filename || 'download'
        a.click()
        return
      }

      // 3) URL de arquivo do backoffice
      const directUrl = td?.file_url || td?.download_url || td?.url
      if (directUrl) {
        const resp = await axiosInstance.get(directUrl, { responseType: 'blob' })
        const blobUrl = window.URL.createObjectURL(resp.data)
        const a = document.createElement('a')
        a.href = blobUrl
        a.download = td.filename || 'download'
        document.body.appendChild(a)
        a.click()
        a.remove()
        URL.revokeObjectURL(blobUrl)
        return
      }

      // 4) Fallback: carrega o show do TextDocument e tenta de novo
      if (td?.id) {
        const show = await axiosInstance.get(
          `${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/text_documents/${td.id}`
        )
        const doc = show?.data?.payload?.text_document

        if (doc?.content) {
          return handleDownload(doc.filename || 'download', doc.content)
        }

        const showUrl = doc?.file_url || doc?.download_url || doc?.url
        if (showUrl) {
          const resp2 = await axiosInstance.get(showUrl, { responseType: 'blob' })
          const blobUrl = window.URL.createObjectURL(resp2.data)
          const a = document.createElement('a')
          a.href = blobUrl
          a.download = doc.filename || 'download'
          document.body.appendChild(a)
          a.click()
          a.remove()
          URL.revokeObjectURL(blobUrl)
          return
        }
      }

      enqueueSnackbar({ variant: 'error', message: 'Não foi possível baixar este arquivo.' })
    } catch (e) {
      enqueueSnackbar({ variant: 'error', message: 'Erro ao baixar o arquivo.' })
    }
  }


  return (
    <AppBar>
      {(!userDetails?.enable_translation && !loading) ?  <Box id="coming-soon" style={{ 
          background: 'white',

           backgroundImage: `url(${forbidden})`, backgroundSize: '50%', backgroundRepeat: 'no-repeat', backgroundPosition: 'center center', width: '100%' }} /> :
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        {loading ? <Box style={{ position:'absolute', top:'50%', left:'50%'}}><CircularProgress /></Box> :
        
        <>
        <Typography className={classes.title} style={{ float: 'left' }} variant="h5" gutterBottom component="h2">
          AI Translator
        </Typography>
        <Box style={{ float: 'right' }}>
          <Box style={{ display: 'flex', flexDirection: 'row', }}>
            {(textareaTranslated || textFileTranslated) &&
              <Box onClick={() => {
                setTextareaTranslation('')
                setTextareaTranslated('')
                setTextFileTranslated('')
                setFile(null)

              }} style={{ color: customTheme.colors.ui.red, marginRight: '1rem', cursor: 'pointer', fontSize: '1.1rem' }}><img style={{ position: 'relative', top: '0.3rem' }} src={iconClean} /> Pulisci</Box>
            }
            {(textareaTranslated || textFileTranslated) &&
              <Box onClick={() => setSaveTranslationModal(true)} style={{ color: customTheme.colors.ui.green, marginRight: '1rem', cursor: 'pointer', fontSize: '1.1rem' }}>Salva</Box>
            }

            <Box onClick={() => setSavedTranslationOpen(true)} style={{ textDecoration: 'underline', marginRight: '1rem', cursor: 'pointer', fontSize: '1.1rem' }}>Archivio</Box>


          </Box>
          {saveTranslationModal &&
            <Dialog
              open={saveTranslationModal}
              onClose={(event, reason) => {
                if (savingTranslation && (reason === 'backdropClick' || reason === 'escapeKeyDown')) {
                  return
                }
                setSaveTranslationModal(false)
              }}
            >
              <Box style={{ width: 400, height: 250, padding: '2rem', display: 'flex', flexDirection: 'column', textAlign: 'center' }}>
                <Typography variant='h5'>Salva la traduzione</Typography>

                <TextField
                  variant='outlined'
                  helperText='Campo obbligatorio'
                  style={{ marginTop: '1.5rem' }}
                  placeholder='Nome del file'
                  value={savedTranslationName ?? ''}
                  onChange={(event) => setSavedTranslationName(event.target.value)}
                  disabled={savingTranslation}              // desabilita enquanto salva
                />

                <Box style={{ marginTop: '1.5rem' }}>
                  <Button
                    onClick={() => setSaveTranslationModal(false)}
                    variant='contained'
                    style={{ marginRight: '1rem' }}
                    disabled={savingTranslation}            // desabilita enquanto salva
                  >
                    Annulla
                  </Button>

                  <Button
                    color='primary'
                    variant='contained'
                    onClick={handleSave}
                    disabled={savingTranslation || !savedTranslationName} // desabilita se salvando ou sem nome
                  >
                    {savingTranslation
                      ? <CircularProgress color='secondary' size={22} />
                      : 'Salva'}
                  </Button>
                </Box>
              </Box>
            </Dialog>
          }

           {openDeleteModal &&
            <Dialog  onClose={() => setOpenDeleteModal(null)} open={openDeleteModal}>
              <Box style={{ width: '400px', height: '250px', padding: '2rem', display: 'flex', flexDirection: 'column', textAlign: 'center' }}>
                <Typography variant='h5'>Conferma richiesta</Typography>
                <Typography style={{marginTop:'1rem', fontSize:'0.9rem'}}>Vuoi davvero eliminare questo file?</Typography>
                <Typography style={{fontSize:'0.9rem'}}>Una volta eliminato, non sarà possibile recuperarlo.</Typography>
                <Box style={{ marginTop: '1.5rem' }}>
                <Button color='primary'  onClick={() => handleDeleteArchive()} variant='contained'>{deletingTranslation ? <CircularProgress color='secondary' size={22} /> : 'Elimina'}</Button>
                </Box>

              </Box>
            </Dialog>
          }
          {savedTranslationOpen &&
            <AppBarHistory style={{ marginTop: '4rem', backgroundColor: 'white', width: '60vw', height: '100%' }}>
              <Box style={{ padding: '20px' }}>
                <Box style={{ display: 'flex', flexDirection: 'row', marginTop: '1rem', alignItems:'center' }}>
                  <ArrowForwardIosIcon onClick={() => setSavedTranslationOpen(false)} style={{ color: 'black', cursor:'pointer' }} />
                  <Typography style={{ color: 'black', marginLeft: '1rem' }} variant='h6'>Archivio</Typography>
                </Box>
                <ul style={{ listStyleType: 'none', lineHeight: 2, height:'75vh', overflow:'auto',  }}>
                  {/* Archivio open */}
                  {savedTranslations.map((translation) => {
                    const userDetailsFormatted = translation?.writable ? userDetails : translation?.user
                    return <Box style={{
                      width: '100%',
                      // backgroundColor: 'red',
                      padding: '1rem',
                      borderRadius: 15,
                      marginBottom: '1rem',
                      boxShadow: `0 0 2px inset ${customTheme.colors.ui.greenVeryLight}`,
                      color: 'black', fontSize: '1rem', display: 'grid',
                      // gridTemplateColumns: '1.6fr 1.6fr 1.6fr 1.6fr',
                      display:'flex',
                      flexDirection:'row',
                      justifyContent:'space-between',
                      alignItems:'center',
                      // gap: '1.5rem'
                    }} key={translation.id}>
                      <Box style={{display:'flex', alignItems:'center', justifyContent:'space-between', width: '90%', paddingRight:'6rem',}}>
                        <Box style={{display:'flex', alignItems:'center', maxWidth:'400px', overflow:'ellipsis'}}><InsertDriveFileIcon style={{ color: 'grey', fontSize: '1.2rem', marginRight: '0.5rem' }} />{translation.name}</Box>
                        
                        <Box style={{display:'flex', alignItems:'center', justifyContent:'center', gap:1, }}>
                          <Box style={{ fontSize: '0.9rem', textAlign: 'right', marginRight:'3rem' }}>{moment(translation.created_at).format('DD MMMM YYYY - hh:mm')}</Box>
                          
                          
                          <Box style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                            <Box style={{
                              marginRight: '0.5rem',
                              width: 22,
                              height: 22,
                              borderRadius: '50%',         
                              display: 'inline-flex',       
                              alignItems: 'center',
                              justifyContent: 'center',
                              background: userDetails?.email?.includes('bancasistema.it') ? '#B91F26' : '#D2AA39',
                              color: 'white',
                              lineHeight: 1,                
                              textTransform: 'uppercase',  
                              }}>{userDetails?.first_name.slice(0, 1)}
                            </Box>
                              {userDetailsFormatted?.first_name} {userDetailsFormatted?.last_name}
                          </Box>
                        </Box>
                      </Box>
                      {/*  */}
                      <Box style={{ textAlign: 'center', display:'flex', alignItems:'center', justifyContent:'center' }}>
                        {translation.writable && 
                          <img 
                            src={condividiSvg} 
                            onClick={(event) => {
                              setAnchorEl2(event.currentTarget);
                              setshowmenu(translation.id)
                            }} 
                            style={{ width: '1.4rem', color: '#707070', marginRight: '0.6rem',cursor:'pointer' }} 
                          />
                        }
                        <DownloadIcon 
                          onClick={() => downloadFromArchive(translation.target_document)} 
                          style={{ marginRight: '0.6rem', color: '#707070', fontSize: '1.4rem',cursor:'pointer'  }} 
                        />
                        {translation.writable && 
                          <img 
                            onClick={() => 
                              setOpenDeleteModal(translation.id)
                            } 
                            style={{ cursor:'pointer', width: '1.4rem'}} 
                            src={deleteIcon} 
                          />
                        }
                      </Box>
                      {/* Menu add User */}
                      {showmenu === translation.id && 
                        <Menu 
                          id="basic-menu"
                          anchorEl={anchorEl2}
                          open={openMenuUser}
                          onClose={handleClose}
                          MenuListProps={{
                            'aria-labelledby': 'basic-button',
                          }}
                        >
                          {users.map(({id, first_name, last_name, email}) => {
                            return (first_name || last_name) && 
                              <MenuItem style={{display: 'block'}} key={id}> 
                                <Box style={{
                                    float:'left',
                                    marginRight: '0.5rem',
                                    // paddingTop:'0.2rem',
                                    borderRadius: '50%', width: '24px', textAlign: 'center',
                                    height: '24px', background: email?.includes('bancasistema.it') ? '#B91F26' : '#D2AA39', color: 'white'

                                    }}>{first_name.slice(0, 1)}
                                  </Box>
                                  <Typography id="basic-menu" style={{ marginRight: '0.5rem',float:'left', }}>
                                    {first_name} {last_name}
                                  </Typography> 

                                  {loadingGrant.includes(email) ? 
                                    <CircularProgress size={12} style={{float:'right'}} /> 
                                    : 
                                    translation?.grantees?.find((grant) => email === grant.email) ? 
                                      <img src={deleteSvg} onClick={() => handleRemoveGrant(translation.id, email)} style={{cursor:'pointer', color:customTheme.colors.ui.red, float:'right'}}   /> 
                                      : 
                                      <AddIcon onClick={() => handleAddGrant(translation.id, email)} style={{cursor:'pointer', color:customTheme.colors.ui.black, float:'right'}} />
                                  }
                                          
                              </MenuItem>
                          })}
                        </Menu>
                      }
                    </Box>
                  })}
                </ul>

              </Box>
            </AppBarHistory>
          }
        </Box>
        <TableContainer>
          <Divider style={{marginBottom: '2rem'}}/>

          <FormControl className={classes.formControl} variant="outlined" style={{backgroundColor:'white'}}>
            <Select
              classes={{ select: classes.selectWhite }}
              displayEmpty
              value={language || ''}
              onChange={(e) => setLanguage(e.target.value)}
              IconComponent={KeyboardArrowDownIcon}
              renderValue={(val) => (
                <Box style={{ width: '100%', textAlign: 'right', color: val ? '#111' : '#9CA3AF' }}>
                  {val ? getLangLabel(val) : 'Scegli'}
                </Box>
              )}
              input={
                <OutlinedInput
                  notched={false}
                  style={{ borderRadius: 15, display:'flex', height:'100%', cursor: 'pointer' }}
                  onMouseDown={(e) => { e.preventDefault(); setOpenOrigin(true) }}
                  startAdornment={
                    <InputAdornment
                      position="start"
                      // faz o clique no label abrir o menu
                      style={{ marginRight: 8, display: 'inline-flex', alignItems: 'center' }}
                    >
                      <img src={worldIcon} alt="" style={{ height: 16, marginRight: 8 }} />
                      <span style={{ color: '#6b7280' }}>Lingua originale</span>
                    </InputAdornment>
                  }
                />
              }
              
              open={openOrigin}
              onOpen={() => setOpenOrigin(true)}
              onClose={() => setOpenOrigin(false)}
              MenuProps={{
                anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
                transformOrigin: { vertical: 'top', horizontal: 'left' },
                getContentAnchorEl: null,
                PaperProps: { style: { borderRadius: 12 } },
              }}
            >
              {languages.map(({ text, value }) => (
                <MenuItem key={value} value={value}>
                  <Box style={{ display: 'flex', alignItems: 'center', fontWeight: language === value? 'bold': 'normal' }}>
                    {language === value
                      ? <CheckIcon fontSize="small" style={{ marginRight: 8 }} />
                      : <Box style={{ width: 18, marginRight: 8 }} />}
                    {text}
                  </Box>
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl className={classes.formControl} variant="outlined" style={{backgroundColor:'white' }}>
            <Select
              classes={{ select: classes.selectWhite }}
              displayEmpty
              value={languageTarget || ''}
              onChange={(e) => setLanguageTarget(e.target.value)}
              IconComponent={KeyboardArrowDownIcon}
              renderValue={(val) => (
                <Box style={{ width: '100%', textAlign: 'right', color: val ? '#111' : '#9CA3AF' }}>
                  {val ? getLangLabel(val) : 'Scegli'}
                </Box>
              )}
              input={
                <OutlinedInput
                  notched={false}
                  style={{ borderRadius: 15, display:'flex', height:'100%', cursor: 'pointer' }}
                  onMouseDown={(e) => { e.preventDefault(); setOpenTarget(true) }}
                  startAdornment={
                    <InputAdornment
                      position="start"
                      style={{ marginRight: 8, display: 'inline-flex', alignItems: 'center' }}
                    >
                      <img src={languageTargetIcon} alt="" style={{ height: 16, marginRight: 8 }} />
                      <span style={{ color: '#6b7280' }}>Lingua target</span>
                    </InputAdornment>
                  }
                />
              }
              open={openTarget}
              onOpen={() => setOpenTarget(true)}
              onClose={() => setOpenTarget(false)}
              MenuProps={{
                anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
                transformOrigin: { vertical: 'top', horizontal: 'left' },
                getContentAnchorEl: null,
                PaperProps: { style: { borderRadius: 12 } },
              }}
            >
              {languages.map(({ text, value }) => (
                <MenuItem key={value} value={value}>
                  <Box style={{ display: 'flex', alignItems: 'center', fontWeight: languageTarget === value ? 'bold' : 'normal' }}>
                    {languageTarget === value
                      ? <CheckIcon fontSize="small" style={{ marginRight: 8 }} />
                      : <Box style={{ width: 18, marginRight: 8 }} />}
                    {text}
                  </Box>
                </MenuItem>
              ))}
            </Select>
          </FormControl>





          <Box 
            className={`file-drop-zone ${isDragging ? 'dragging' : ''}`}
            onDragEnter={handleDragEnter}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
            style={{
              width: '100%', marginTop: '1.5rem', display: 'grid', height:'53vh',
              gridTemplateColumns: '1fr 1fr',
              gap: '1rem', 

            }}>
            <Box style={{
              display: 'grid',
              gridTemplateColumns: '1fr',
            }}>



              <Box style={{
                gridRowStart: 1,
                gridColumnStart: 1,

              }}>
                {file ? <Box style={{ border: '1px solid #000', paddingTop: '0.5rem', border: 'none', borderColor: 'none', resize: 'none', width: '100%', borderRadius: 15, height: '53vh', boxShadow: `0 0 2px inset ${customTheme.colors.ui.greenVeryLight}` }}>
                  <Box style={{ backgroundColor: customTheme.colors.ui.greyLight, padding: '1rem', borderRadius: 15, margin: '0.7rem 1rem' }}>
                    <TextSnippetIcon style={{ float: 'left', marginRight: '0.5rem', color: customTheme.colors.ui.grey }} />
                    {file.name}
                    <CloseIcon onClick={() => {
                      setFile(null)
                      setTextFileTranslated('')
                    }} style={{ float: 'right', cursor: 'pointer', marginRight: '0.5rem', color: customTheme.colors.ui.grey, }} />
                  </Box>
                </Box>
                  :
                  <textarea ref={textareaRef} value={textareaTranslation || ''} onChange={(event) => setTextareaTranslation(event.target.value)} className={classes.textarea} />
                }
              </Box>
              {!file && !textareaTranslation && 
              <Box 
                style={{
                  textAlign: 'center',
                  gridRowStart: 1,
                  gridColumnStart: 1, 
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  cursor: 'text',
                }}
                onClick={() => textareaRef.current?.focus()} 
              >
                <input accept=".docx , .doc , .pptx , .xlsx , .pdf , .html , .txt , .xlf , .xliff , .srt" style={{ display: 'none' }} ref={inputRef} type='file' hidden onClick={(event) => {
                  event.target.value = null
                }} onChange={handleFileUpload} />
                <Box style={{ width:'60%', marginBottom:'2rem'}}>
                  <Typography style={{ lineHeight: 1.5 }}> Scrivi qui il tuo testo oppure <br /> <span style={{ textDecoration: 'underline', cursor: 'pointer' }} onClick={(e) => { e.stopPropagation(); handleClickFileUpload(e) }}>Carica un file</span> o trascinalo direttamente</Typography>
                  <Typography style={{ lineHeight: 1.5, fontSize:'0.9rem', fontSize: '0.9rem', marginTop:'0.5rem', color:'#7f7f7f'}}>(Tipi di file supportati: docx, pptx, xlsx, pdf, txt, <br />html, xlf/xliff, srt. Dimensione massima: 30 MB)</Typography>
                </Box>
              </Box>
              }

            </Box>




            {textFileTranslated && file ?
              <Box style={{ border: '1px solid #000', paddingTop: '1rem', border: 'none', borderColor: 'none', resize: 'none', width: '100%', borderRadius: 15, height: '53vh', boxShadow: `0 0 2px inset ${customTheme.colors.ui.greenVeryLight}` }}>
                <Box style={{ backgroundColor: customTheme.colors.ui.greyLight, padding: '1rem', borderRadius: 15, margin: '0.7rem 1rem' }}>
                  <TextSnippetIcon style={{ float: 'left', marginRight: '0.5rem', color: customTheme.colors.ui.grey }} />
                  {`${file.name.replace(/(\.[\w\d_-]+)$/i, '_tradotto')}`}
                  <Box onClick={() => downloadTranslated(textFileTranslated)}  style={{ float: 'right', cursor: 'pointer', marginRight: '0.5rem', color: customTheme.colors.ui.red, textDecoration: 'underline' }}>
                    Vai al documento tradotto
                  </Box>
                </Box>
              </Box>
              :
              <Box>

                <textarea
                  className={classes.textarea}
                  style={{ boxShadow: `0 0 3px inset ${customTheme.colors.ui.greenVeryLight}` }}
                  disabled={!textareaTranslated || !textFileTranslated}
                  value={textareaTranslated || ''}
                  onChange={(e) => setTextareaTranslated(e.target.value)}
                />
                {textareaTranslated && <><DownloadIcon onClick={handleClickPopover} style={{ cursor: 'pointer', float: 'right', position: 'relative', right: '1rem', bottom: '2.5rem' }} />
                <Tooltip  onClick={() => copyToClipboard()}  open={Boolean(tooltipClip)} title={tooltipClip}><ContentCopyIcon style={{fontSize:'1.4rem', cursor: 'pointer', float: 'right', position: 'relative', right: '1.2rem', bottom: '2.5rem'  }} /></Tooltip>
                </>
                }

              </Box>

            }

            <Popover
              id={id}

              open={open}
              anchorEl={anchorEl}
              onClose={handleClosePopover}

              transformOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
            >
              <Box style={{ padding: '1.2rem 1rem 1rem 1rem' }}>
                <span style={{ fontWeight: 'bold', }}>Scarica:</span>
                <Box style={{ display: 'flex', flexDirection: 'column', textAlign: 'left', lineHeight: 2.2, marginTop:'0.5rem' }}>

                  <Button onClick={() => handleDownloadCartaIntestata('letterhead', textareaTranslated)}  style={{justifyContent:'left', paddingLeft:0}}>Carta Intestata BS</Button>
                  <Button onClick={() => handleDownloadCartaIntestata('pressrelease_it', textareaTranslated)} style={{justifyContent:'left', paddingLeft:0}}>Comunicato Stampa BS ita</Button>
                  <Button onClick={() => handleDownloadCartaIntestata('pressrelease_en', textareaTranslated)} style={{justifyContent:'left', paddingLeft:0}}>Comunicato Stampa BS eng</Button>

                </Box>
              </Box>
            </Popover>
          </Box>
          <Box style={{ width: '100%', textAlign: 'center', marginTop: '1.5rem' }}>
            <Button color='primary' disabled={(!textareaTranslation && !file) || !language || !languageTarget || translating} style={{ width: '8rem' }} onClick={() => (textareaTranslation || file) && language && languageTarget && handleTranslation()} variant='contained'>{translating ? <CircularProgress color='secondary' size={22} /> : 'Traduci'}</Button>
          </Box>



        </TableContainer>
        </>}
      </main>
}
    </AppBar>

  )
}

export default Translator